import React, { useState } from "react";

import { IonText, IonInput, IonItem, IonLabel, IonToast } from "@ionic/react";

import Page from "../../components/Page/Page";

import { ButtonLoading } from "../../components/Ui/ButtonLoading";

import { useRecover } from "../../hooks/useRecover";
import { useValidation } from "../../hooks/useValidation";
import { useChange } from "../../hooks/useChange";

import { ContactSend } from "./ContactSend";

export const RecoverPage: React.FC<{}> = () => {
  const [state, setState] = useState({ email: "" });
  const { loading, onSubmit, error, success, cancelError } = useRecover(state);
  const { isValid } = useValidation(state, { email: false });

  const { onIonChange } = useChange({ setState });

  return (
    <Page back name="Recuperação de conta">
      <IonToast
        isOpen={error}
        position="bottom"
        message="Não foi possível enviar à solicitação"
        duration={3000}
        onDidDismiss={() => cancelError()}
        buttons={[{ text: "Ok", role: "cancel", handler: () => cancelError() }]}
      />
      {success ? <ContactSend /> : null}
      {!success ? (
        <div style={{ marginTop: "1.5rem" }}>
          <IonText>
            <h4 style={{ textAlign: "center" }}>Esqueceu sua senha?</h4>
          </IonText>
          <p style={{ textAlign: "center", fontSize: "15px" }}>
            Não se preocupe! Insira o seu e-mail de cadastro e enviaremos
            instruções para você.
          </p>
          <form onSubmit={onSubmit}>
            <div style={{ padding: 10 }}>
              <IonItem>
                <IonLabel position="floating">
                  E-mail <IonText color="danger">*</IonText>
                </IonLabel>
                <IonInput
                  required
                  onIonChange={onIonChange}
                  type="text"
                  name="email"
                />
              </IonItem>
              <div style={{ display: "flex" }}>
                <ButtonLoading
                  style={{
                    height: 40,
                    margin: "1rem auto",
                    textTransform: "initial",
                    fontSize: "1rem",
                    width: "60%",
                    "--background": "var(--ion-color-brand-secondary)",
                  }}
                  loading={loading}
                  disabled={isValid()}
                  text="Receber instruções"
                  textLoading="Enviando instruções..."
                />
              </div>
            </div>
          </form>
        </div>
      ) : null}
    </Page>
  );
};
